import React, {useState} from 'react'
import {getBrandById, updateBrand} from "../../services/serviceBrand";
import {Button, Form, Input, Modal} from "antd";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";


const { TextArea } = Input

const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const BrandEdit = ({brand, updater}) => {
    const [form] = Form.useForm()
    const [editModal, setEditModal] = useState(false)
    const [loadings, setLoadings] = useState([])

    const handleEditClick = () => {
        getBrandById(brand.id)
            .then(({data}) => {
                form.setFieldsValue({
                    brandName: data.name,
                    brandCode: data.code,
                    brandDescription: data.description
                })
            })
        setEditModal(!editModal)
    }

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            name: list.brandName,
            code: list.brandCode,
            description: list.brandDescription,
            id: brand.id
        }
        updateBrand(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                setEditModal(!editModal)
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return(
        <React.Fragment>
            <Button type={'link'} onClick={()=>handleEditClick()}>Güncelle</Button>

            <Modal
                open={editModal}
                closable={false}
                title={`Güncelle`}
                footer={[
                    <Button type={'primary'} key={'SubmitButton'} loading={loadings[0]} onClick={()=>form.submit()}>Kaydet</Button>,
                    <Button onClick={() => setEditModal(!editModal)} key={'CloseButton'} >Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >
                    <Form.Item
                        label={'Marka Adı'}
                        name={'brandName'}
                        rules={[
                            {required: true, message: 'Marka Adı Alanı Boş Bırakılamaz'},
                            {min: 1, max: 300, message: 'Marka Adı En Az 5 En Fazla 300 Karakter Olmalı'}
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={'Marka Kodu'}
                        name={'brandCode'}
                        rules={[
                            {required: true, message: 'Marka Kodu Alanı Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Marka Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 20, message: 'Marka Kodu En Az 3 En Fazla 20 Karakter Olmalı'}
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={'Marka Açıklaması'}
                        name={'brandDescription'}
                        rules={[
                            {min: 1, max: 1000, message: 'Marka Açıklaması En az 1 En Fazla 1000 Karakter Olmalı'}
                        ]}
                    >
                        <TextArea />
                    </Form.Item>
                </Form>
            </Modal>

        </React.Fragment>
    )
}
export default BrandEdit